var _path, _line, _line2, _line3, _line4, _line5, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 25.5537C22.6062 26.7746 21.6165 27.7644 20.3956 27.7644H2.71062C1.48973 27.7644 0.5 26.7746 0.5 25.5537V2.71062C0.5 1.48973 1.48973 0.5 2.71062 0.5H20.3956C21.6165 0.5 22.6062 1.48973 22.6062 2.71062V18.0179",
    stroke: "#0A0B0C",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.44785,
    y1: 5.28781,
    x2: 19.6591,
    y2: 5.28781,
    stroke: "#0A0B0C",
    strokeWidth: 0.736874
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.44785,
    y1: 9.70969,
    x2: 19.6591,
    y2: 9.70969,
    stroke: "#0A0B0C",
    strokeWidth: 0.736874
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.44785,
    y1: 14.1316,
    x2: 19.6591,
    y2: 14.1316,
    stroke: "#0A0B0C",
    strokeWidth: 0.736874
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.44785,
    y1: 18.5534,
    x2: 15.9747,
    y2: 18.5534,
    stroke: "#0A0B0C",
    strokeWidth: 0.736874
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.44785,
    y1: 22.9753,
    x2: 15.9747,
    y2: 22.9753,
    stroke: "#0A0B0C",
    strokeWidth: 0.736874
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0845 19.7578C25.2199 19.8932 25.2199 20.1128 25.0845 20.2482L21.6168 23.7159C21.4814 23.8513 21.2619 23.8513 21.1264 23.7159L19.3926 21.982C19.2572 21.8466 19.2572 21.6271 19.3926 21.4916C19.528 21.3562 19.7476 21.3562 19.883 21.4916L21.3716 22.9803L24.5941 19.7578C24.7295 19.6224 24.9491 19.6224 25.0845 19.7578Z",
    fill: "#0A0B0C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.08cbc48e9f076de58e5959ec8b532f8b.svg";
export { ForwardRef as ReactComponent };